(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Zenith Blade": {
      targets: [{ bind: "t", spec: { type: "unit", enemy: true, atBf: true }, prompt: "Stun an enemy unit at a battlefield" }],
      play: [
        { op: "stun", to: "$t" },
        {
          op: "may", prompt: "Move a friendly unit to that battlefield?",
          then: [
            { op: "choose", spec: { type: "unit", friendly: true }, bind: "m", prompt: "Move which friendly unit?" },
            { op: "move", to: "$m", destRef: "$t" },
          ],
        },
      ],
    },

    "Radiant Dawn": {
      triggers: [{
        on: "stunned",
        condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evEnemy" }] },
        label: "buff a friendly unit",
        targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Buff a friendly unit" }],
        program: [{ op: "buff", to: "$t" }],
      }],
    },

    "En Garde": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Give which friendly unit +1 Might?" }],
      play: [
        buff("$t", 1),
        { op: "if", cond: { k: "aloneAt", bind: "t" }, then: [buff("$t", 1)] },
      ],
    },

    "Meditation": {
      play: [
        { op: "choose", spec: { type: "unit", friendly: true, ready: true }, bind: "e", min: 0, max: 1, prompt: "Exhaust a friendly unit to draw 2 instead of 1?" },
        {
          op: "if", cond: { k: "targetsChosen", bind: "e" },
          then: [{ op: "exhaust", to: "$e" }, { op: "draw", n: 2 }],
          else: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Wielder of Water": {
      selfMightSpecs: [{ n: 2, cond: { k: "and", conds: [{ k: "inCombat" }, { k: "aloneHere" }] } }],
    },

    "Poro Herder": {
      play: [{
        op: "if", cond: { k: "controlsTag", tag: "Poro" }, then: [
          { op: "buff", to: "source" },
          { op: "draw", n: 1 },
        ],
      }],
    },

    "Blitzcrank, Impassive": {
      play: [{
        op: "if", cond: { k: "ctxBf" }, then: [{
          op: "may", prompt: "Move an enemy unit to Blitzcrank's battlefield?", then: [
            { op: "choose", bind: "t", spec: { type: "unit", enemy: true }, prompt: "Move which enemy unit here?" },
            { op: "move", to: "$t", dest: "here" },
          ],
        }],
      }],
      triggers: [{
        on: "hold", selfBf: true, you: true, label: "return to hand",
        program: [{ op: "toHand", to: "source" }],
      }],
    },

    "Yasuo, Remorseful": {
      triggers: [{
        on: "attack", self: true, label: "storm strike",
        program: [
          { op: "choose", bind: "t", spec: { type: "unit", enemy: true, here: true }, prompt: "Deal Yasuo's Might to which enemy unit here?" },
          { op: "deal", to: "$t", n: "sourceMight" },
        ],
      }],
    },

    "Mask of Foresight": {
      triggers: [
        {
          on: "attack", label: "foresight",
          condSpec: { k: "and", conds: [{ k: "evFriendly" }, { k: "evAloneAtEvBf" }] },
          program: [{ op: "grant", to: "$ev", might: 1 }],
        },
        {
          on: "defend", label: "foresight",
          condSpec: { k: "and", conds: [{ k: "evFriendly" }, { k: "evAloneAtEvBf" }] },
          program: [{ op: "grant", to: "$ev", might: 1 }],
        },
      ],
    },

    "Eclipse Herald": {
      triggers: [{
        on: "stunned", you: true, label: "eclipse",
        condSpec: { k: "evEnemy" },
        program: [
          { op: "ready", to: "source" },
          { op: "grant", to: "source", might: 1 },
        ],
      }],
    },

    "Ahri, Alluring": {
      triggers: [{
        on: "hold", selfBf: true, you: true, label: "charm point",
        program: [{ op: "points", n: 1 }],
      }],
    },

    "Adaptatron": {
      triggers: [{
        on: "conquer", selfBf: true, you: true, label: "salvage parts",
        program: [{
          op: "may", prompt: "Kill a gear to buff Adaptatron?", then: [
            { op: "choose", bind: "g", spec: { type: "gear" }, prompt: "Kill which gear?" },
            {
              op: "if", cond: { k: "targetsChosen", bind: "g" }, then: [
                { op: "kill", to: "$g" },
                { op: "buff", to: "source" },
              ],
            },
          ],
        }],
      }],
    },

    "Taric, Protector": {
      auraKwSpecs: [{ name: "shield", value: 1, scope: "hereBf", excludeSelf: true }],
    },

    "Wizened Elder": {
      selfMightSpecs: [{ n: 1, cond: { k: "selfHasBuff" } }],
    },

    "Spirit's Refuge": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Buff which friendly unit?" }],
      play: [{ op: "buff", to: "$t" }],
      auraKwSpecs: [{ name: "deflect", value: 1, targetCond: { k: "selfHasBuff" } }],
    },

    "Find Your Center": {
      costMod: { k: "oppNearWin", within: 3, energyLess: 2, min: 0 },
      play: [
        { op: "draw", n: 1 },
        { op: "channel", n: 1, exhausted: true },
      ],
    },

    "Lee Sin, Ascetic": {
      multiBuff: true,
      abilities: [{
        label: "Exhaust: buff me", exhausts: true,
        program: [{ op: "buff", to: "source" }],
      }],
    },

    "Tasty Faefolk": {
      deathknell: [
        { op: "channel", n: 2, exhausted: true },
        { op: "draw", n: 1 },
      ],
    },

    "Stand United": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Buff which friendly unit?" }],
      play: [
        { op: "buff", to: "$t" },
        { op: "grant", spec: { type: "unit", friendly: true }, buffBonus: 1 },
      ],
    },

    "Block": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Give [Shield 3] and [Tank] to which unit?" }],
      play: [
        { op: "grant", to: "$t", keyword: "shield", kwValue: 3 },
        { op: "grant", to: "$t", keyword: "tank" },
      ],
    },

    "Last Stand": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Double whose Might (and give it Temporary)?" }],
      play: [
        { op: "grant", to: "$t", might: { mightOf: "$t" } },
        { op: "grant", to: "$t", keyword: "temporary", dur: "perm" },
      ],
    },

    "Dragon's Rage": {
      targets: [{ bind: "a", spec: { type: "unit", enemy: true }, prompt: "Move which enemy unit?" }],
      play: [
        { op: "move", to: "$a" },
        { op: "choose", bind: "b", spec: { type: "unit", enemy: true, sameLocAs: "a", notBind: "a" }, prompt: "It fights which enemy unit at its destination?" },
        { op: "fight", a: "$a", b: "$b" },
      ],
    },

    "Last Breath": {
      targets: [{ bind: "a", spec: { type: "unit", friendly: true }, prompt: "Ready which friendly unit?" }],
      play: [
        { op: "ready", to: "$a" },
        { op: "choose", bind: "b", spec: { type: "unit", enemy: true, atBf: true }, prompt: "It deals its Might to which enemy unit?" },
        { op: "deal", to: "$b", n: { mightOf: "$a" } },
      ],
    },

    "Party Favors": {
      play: [
        { op: "option", byOpponent: true, prompt: "Party Favors: choose Cards or Runes", options: ["Cards", "Runes"], varKey: "pf" },
        { op: "if", cond: { k: "varEq", key: "pf", value: 0 }, then: [{ op: "draw", n: 1, who: "each" }] },
        {
          op: "if", cond: { k: "varEq", key: "pf", value: 1 }, then: [
            { op: "channel", n: 1, exhausted: true },
            { op: "channel", n: 1, exhausted: true, who: "opponent" },
          ],
        },
      ],
    },

    "Defy": {
      targets: [{ bind: "t", spec: { type: "spell", zone: "chain", maxEnergy: 4, maxPips: 1, counterable: true }, prompt: "Counter which spell (cost 4 or less, 1 pip or less)?" }],
      play: [{ op: "counter", to: "$t" }],
    },

    "Caitlyn, Patrolling": {
      selfKwSpecs: [{ name: "backline", value: null }],
      abilities: [{
        label: "Exhaust: deal my Might to a unit at a battlefield", exhausts: true, needBf: true,
        program: [
          { op: "choose", bind: "t", spec: { type: "unit", atBf: true }, prompt: "Deal Caitlyn's Might to which unit?" },
          { op: "deal", to: "$t", n: "sourceMight" },
        ],
      }],
    },

    "Blind Monk": {
      abilities: [{
        label: "1 energy, exhaust: buff a friendly unit", exhausts: true, cost: { energy: 1 },
        program: [
          { op: "choose", bind: "t", spec: { type: "unit", friendly: true }, prompt: "Buff which unit?" },
          { op: "buff", to: "$t" },
        ],
      }],
    },

    "Unforgiven": {
      abilities: [{
        label: "2 energy, exhaust: move a friendly unit to or from its base", exhausts: true, cost: { energy: 2 },
        program: [
          { op: "choose", bind: "t", spec: { type: "unit", friendly: true }, prompt: "Move which unit?" },
          { op: "move", to: "$t" },
        ],
      }],
    },

    "Nine-Tailed Fox": {
      triggers: [{
        on: "attack", label: "beguile",
        condSpec: { k: "and", conds: [{ k: "evEnemy" }, { k: "evBfMine" }] },
        program: [{ op: "grant", to: "$ev", might: -1, floor: 1 }],
      }],
    },

    "Reinforce": {
      play: [{
        op: "lookTopTake", n: 5, optional: true, filter: { type: "unit" },
        prompt: "Banish a unit from among them and play it for 5 less", energyLess: 5,
      }],
    },

    "Solari Shrine": {
      triggers: [{
        on: "dies", optional: true, exhaustSelf: true, label: "exhaust to draw 1",
        condSpec: { k: "and", conds: [{ k: "selfReady" }, { k: "evSnapshotStunned" }, { k: "evSnapshotEnemy" }, { k: "evKilledByMe" }] },
        program: [{ op: "exhaust", to: "source" }, { op: "draw", n: 1 }],
      }],
    },

    "Sona, Harmonious": {
      triggers: [{
        on: "endOfTurn", you: true, label: "ready 4 runes",
        condSpec: { k: "selfAtBf" },
        program: [{ op: "readyRunes", n: 4 }],
      }],
    },

    "Zhonya's Hourglass": {
      staticDeathReplace: {
        who: "friendly", mandatory: true, killsSource: true,
        label: "Zhonya's Hourglass",
      },
    },

    "Leona, Zealot": {
      entersReadyCond: { k: "oppNearWin", n: 3 },
      auraMightSpecs: [{
        n: -8, floor: 1, who: "enemyUnits", scope: "here",
        targetCond: { k: "targetStunnedEnemy" },
      }],
    },

    "Mystic Reversal": {
      targets: [{ bind: "t", spec: { type: "spell", zone: "chain" }, prompt: "Gain control of which spell?" }],
      play: [{ op: "takeSpellControl", to: "$t", rechoose: true }],
    },

    "Fox-Fire": {
      play: [{
        op: "killBudget", n: 4, sameBf: true, spec: { type: "unit", atBf: true },
        prompt: "Kill units at one battlefield",
      }],
    },

    "Clockwork Keeper": {
      addCosts: [
        {
          optional: true,
          cond: null,
          label: "Clockwork Keeper",
          cost: { energy: 0, pips: 1, anyPower: 0, domains: ["calm"] },
          then: [{ op: "draw", n: 1 }],
          thenTargets: [],
        },
      ],
    },

    "Mageseeker Warden": {
      auraRestrictPlay: { allowType: "unit", toBaseOnly: true },
      auraRestrictScope: "atBf",
      auraNoEnemyReady: true,
    },

    "Seal of Focus": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [
            {
              op: "addResources",
              res: { energy: 0, pips: 1, anyPower: 0, domains: ["calm"] },
            },
          ],
          label: "Add",
        },
      ],
    },

    "Charm": {
      play: [{ op: "move", to: "$t1", dest: "choose" }],
      targets: [{ bind: "t1", spec: { type: "unit", enemy: true }, prompt: "Move..." }],
    },

    "Discipline": {
      play: [buff("$t1", 2), { op: "draw", n: 1 }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +2 Might to..." }],
    },

    "Playful Phantom": {},

    "Rune Prison": {
      play: [{ op: "stun", to: "$t1" }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Stun..." }],
    },

    "Solari Shieldbearer": {
      play: [{ op: "stun", to: "$t1" }],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Stun..." }],
    },

    "Stalwart Poro": {},

    "Sunlit Guardian": {},

    "Whiteflame Protector": {
      play: [buff("$t1", 8)],
      targets: [{ bind: "t1", spec: { type: "unit" }, prompt: "Give +8 Might to..." }],
    },

    "Wind Wall": {
      play: [{ op: "counter", to: "$t1" }],
      targets: [
        {
          bind: "t1",
          spec: { type: "spell", zone: "chain", enemy: false, counterable: true },
          prompt: "Counter...",
        },
      ],
    },
  });
})();
